import type { ReactElement } from 'react';
import { useLogin } from '@refinedev/core';
import { Button, Card, Form, Input, Layout, theme, Typography } from 'antd';

const { Title } = Typography;

interface LoginFormValues {
  username: string;
  password: string;
}

export function LoginPage(): ReactElement {
  const { mutate: login, isLoading } = useLogin<LoginFormValues>();
  const { token } = theme.useToken();

  return (
    <Layout
      style={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: token.colorBgLayout,
      }}
    >
      <Card
        style={{ width: 400, maxWidth: '90vw' }}
        title={
          <Title
            level={3}
            style={{ textAlign: 'center', marginBottom: 0, marginTop: 8 }}
          >
            Woolaby Admin
          </Title>
        }
      >
        <Form<LoginFormValues>
          layout="vertical"
          initialValues={{ username: '', password: '' }}
          onFinish={(values) => login(values)}
        >
          <Form.Item
            name="username"
            label="Email"
            rules={[{ required: true, message: 'Email is required' }]}
          >
            <Input size="large" placeholder="Email" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Password is required' }]}
          >
            <Input.Password size="large" placeholder="●●●●●●●●" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={isLoading}
              block
            >
              Sign in
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Layout>
  );
}
